import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

import { computed, Raw, ref } from 'vue'
import { useRouter } from 'vue-router'

import { CreateCustomListForm, CustomListsView } from '@/models/custom.lists'
import { ListView } from '@/models/docs.list'

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import CollectionCard from '@/app/components/collections/card/CollectionCard.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import CustomListForm from '@/app/components/custom.lists/CustomListForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomListsBlock',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const docsView = computed(() => {
  return props.view.docs() as CustomListsView
})

const router = useRouter()

const customListForm = ref<InstanceType<typeof CustomListForm> | null>(null)
const createListFormView = ref<Raw<CreateCustomListForm>>(
  new CreateCustomListForm(undefined, true, router),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, {
    class: "listing-block listing-block--custom-lists",
    title: __props.view.pageTitle(),
    numberOfColumns: 4
  }, {
    headerActions: _withCtx(() => [
      _createVNode(AppButton, {
        class: "listing-block__new-list-btn",
        icon: "iadd",
        onClick: customListForm.value?.show
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Create List", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(CustomListForm, {
        ref_key: "customListForm",
        ref: customListForm,
        class: "listing-block__new-list-form",
        view: createListFormView.value
      }, null, 8, ["view"])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docsView.value.filteredDocs, (doc) => {
        return (_openBlock(), _createBlock(CollectionCard, {
          key: doc.id,
          doc: doc,
          view: docsView.value,
          coverImages: docsView.value.coverImages(doc)
        }, {
          default: _withCtx(() => [
            (!doc.is_standard)
              ? (_openBlock(), _createBlock(CustomListMenu, {
                  key: 0,
                  list: doc,
                  listsView: docsView.value,
                  positon: "right"
                }, null, 8, ["list", "listsView"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["doc", "view", "coverImages"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})